module.exports = __webpack_public_path__ + "assets/img/nextIcon.82631a9d.svg";